import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'widgets/Paper';
import CircularProgress from 'widgets/CircularProgress';
import colors from 'assets/styles/jsVariables/colors';

export default function Loader(props) {
  const { zDepth } = props;
  const { progressColor } = props;
  return (
    <Paper
      style={{
        textAlign: 'center',
        backgroundColor: colors.white,
        padding: '30px 0px',
        ...props.style
      }}
      elevation={zDepth}
    >
      <CircularProgress size={30} color={progressColor} />
    </Paper>
  );
}

Loader.defaultProps = {
  zDepth: 1,
  style: {},
  progressColor: colors.lighterCyan
};

Loader.propTypes = {
  zDepth: PropTypes.number,
  style: PropTypes.object,
  progressColor: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Loader/ContentLoader.jsx